import "./TutorialModal.css";
import { useEffect, useState } from "react";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import Modal from "react-bootstrap/Modal";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { useSelector, useDispatch } from "react-redux";
import BubbleSvgButton from "../BubbleSvgButton/BubbleSvgButton";
import TutorialStart from "./TutorialStart";
import TutorialData from "./TutorialData";
import TutorialInsightfull from "./TutorialInsightfull";
import TutorialDatesCal from "./TutorialDatesCal";
import AskingServices from "./AskingServices";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity.js";
import { useNavigate } from "react-router-dom";
import { showTradeNameAtom } from "../../../../store/globalstore";
import { useAtom } from "jotai";
import { storeUser } from "../../../../redux/users/usersSlice.js";
import { showNotificationToast } from "../../../../helpers/toast/toastify.js";

const CustomTutorialModal = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [show, setShow] = useState(false);
  const [showTradeNamePopUp, setShowTradeNamePopUp] =
    useAtom(showTradeNameAtom);
  const { user } = useSelector((state) => state.user);
  const [commmingFor, setCommingFor] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [role, setUserRole] = useState(null);
  const api = useApi();

  const handleClose = async () => {
    const response = await api("post", "authorizeNewonBoard/watchTutorial", {
      purposeOfJoining: commmingFor,
    });
    if (response?.status) {
      // setShow(false);
      const response = await api("get", "users/index");
      if (response?.status) {
          showNotificationToast("Welcome! We're happy you're here!","");
          const { data } = response;
          if (dispatch && storeUser) dispatch(storeUser(data));
          if (data?.token) localStorage.setItem("token", data.token);
        }
      } 
      // if (commmingFor === "Verify Your Trading" && user?.role === "leader") {
      //   setShowTradeNamePopUp(true);
      //   navigate("/leader/addTradeName");
      // } else {
      //   console.log("`/${user?.role}/dashboard`", `/${user?.role}/dashboard`);
        
      //   navigate(`/${user?.role}/dashboard`);
      // }
    
  };
  const handleSwitchClick = (slideNumber) => setActiveSlide(slideNumber);

  const handleNext = () => {
    setActiveSlide((nextSlide) => nextSlide + 1)
  };

  const handlePrev = () => setActiveSlide((prevSlide) => prevSlide - 1);
  useEffect(() => {
    if (Object.keys(user || {})?.length) {
      setShow(!user?.isWatchTutorial);
      setUserRole(user?.role);
    }

    if (showTradeNamePopUp) {
      navigate(`/${user?.role}/addTradeName`);
    }
  }, [user]);

  useEffect(() => {
    setActiveSlide(user?.role === "leader" ? 0 : 1);
  }, [user]);

  return (
    <div className="tutorial-modal-wrapper">
      <Modal
        backdropClassName="custom-backdrop"
        centered
        dialogClassName="custom-tutorial-modal"
        show={show}
      >
        <Modal.Body>
          <>
            <div className={`tutorial-slide`}>
              {(activeSlide > 1) && (
                <button
                  className="headerArrowBtn"
                  onClick={handlePrev}
                  type="button"
                >
                  <img alt="" src={Arrow} />
                </button>
              )}

              {activeSlide === 0 && (
                <div className="shownServicesBox">
                  <AskingServices
                    handleNext={handleNext}
                    setCommingFor={setCommingFor}
                  />
                </div>
              )}

              {activeSlide === 1 && (
                <TutorialStart
                  title="Start copying a trader"
                  description="Just hit this button and select a trader to copy from the market place."
                />
              )}
              {activeSlide === 2 && (
                <TutorialData
                  title={user?.role==="leader"?"No data":"Platform data"}
                  description={user?.role==="leader"?"Until you set up your copy trading and first trades are done":"Platform will start showing data once you’ve subscribed to a copy trade."}
                />
              )}
              {!(activeSlide === 0) && (
                <>
                  <BubbleSvgButton
                    className="tutorialNextBtn"
                    onClick={() => {


                      if (activeSlide === 2) handleClose();
                      else handleNext();
                    }}
                    text={activeSlide === 2 ? "Ok, let’s go!" : "Next"}
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    mainDivStyle={{
                      width: "auto",
                      height: "auto",
                      position: "absolute",
                      left: "50%",
                      bottom: "60px",
                      transform: "translateX(-50%)",
                    }}
                  />

                  <div className="tutorialHeaderBox">
                    <div className="switcher">
                      {/* onClick removed — bullets are visual-only indicators, not navigation (CSS pointer-events:none also set) */}
                      <button
                        className={`switch ${activeSlide === 1 ? "active" : ""
                          }`}
                        // onClick={() => handleSwitchClick(1)}
                        type="button"
                      ></button>
                      <button
                        className={`switch ${activeSlide === 2 ? "active" : ""
                          }`}
                        // onClick={() => handleSwitchClick(2)}
                        type="button"
                      ></button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CustomTutorialModal;
